import { LastMatchesChip } from './props';
import styles from './styles.module.scss';
import Link from '@/components/core/Link';
import { PropsWithChildren, memo } from 'react';

function LastMatchChip({
  won,
  isBackgroundPaper,
  isLoading,
  cover,
  link,
  modal,
  children,
}: PropsWithChildren<LastMatchesChip>) {
  if (isLoading) {
    if (cover) {
      return <div className={styles['skeleton--cover']} />;
    }

    return (
      <div
        className={
          isBackgroundPaper ? styles['skeleton--paper'] : styles.skeleton
        }
      />
    );
  }

  return (
    <Link
      href={link}
      modal={modal}
      className={`${styles.link} ${isBackgroundPaper ? styles['link--paper'] : ''} ${cover ? styles['link--cover'] : ''} ${won ? styles['link--won'] : ''}`}
    >
      {children}
    </Link>
  );
}

export default memo(LastMatchChip);
